import { BackgroundVideoSkinElement } from '../../presets/background/skin';
import { safeDefine } from '../../registration/safe-define';
import '../ui/container';

safeDefine(BackgroundVideoSkinElement);
